import {LebensbausteinButton} from "../WidgetObjectList"
import {useDraggable} from "@dnd-kit/core"
import React from "react"

const DraggableItem = ({id, style, children}) => {
    const {attributes, listeners, setNodeRef, transform} = useDraggable({id})

    return (
        <LebensbausteinButton
            ref={setNodeRef}
            {...listeners}
            {...attributes}
            variant="primary"
            sx={{
                zIndex: 1000,
                position: "absolute",
                top: 0,
                left: 0,
                userSelect: "none",
                color: "#1D41CF",
                ...style,
            }}
            style={{
                transform: transform
                    ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
                    : undefined,
            }}>
            {children}
        </LebensbausteinButton>
    )
}

export default DraggableItem